export default __webpack_public_path__ + "7b78bd6e1577d1df01a7285ed142d5bf.png";